export const IMG = {
  heroCoast: "https://images.unsplash.com/photo-1760697443035-35cd4b65182e?crop=entropy&cs=srgb&fm=jpg&q=85",
  maquis: "https://images.unsplash.com/photo-1603907102676-cf437a6bd3f9?crop=entropy&cs=srgb&fm=jpg&q=85",
  pool: "https://images.unsplash.com/photo-1785013045428-d7c3d9535239?crop=entropy&cs=srgb&fm=jpg&q=85",
  interiorStone: "https://images.unsplash.com/photo-1780170008509-d2dee1c7479d?crop=entropy&cs=srgb&fm=jpg&q=85",
  coastAerial: "https://images.unsplash.com/photo-1787945834756-168e85fa1bce?crop=entropy&cs=srgb&fm=jpg&q=85",
  redRocks: "https://images.unsplash.com/photo-1787945834126-f42cef30da03?crop=entropy&cs=srgb&fm=jpg&q=85",
  coastRugged: "https://images.unsplash.com/photo-1787945834179-5f32dbfcf11a?crop=entropy&cs=srgb&fm=jpg&q=85",
  hillTown: "https://images.unsplash.com/photo-1651415830725-930d806b578d?crop=entropy&cs=srgb&fm=jpg&q=85",
  mountainSea: "https://images.unsplash.com/photo-1587032286160-e6b508ed7226?crop=entropy&cs=srgb&fm=jpg&q=85",
  boat: "/assets/services/bateau.webp",
  boatSail: "https://images.unsplash.com/photo-1635184612919-ec2585c67008?crop=entropy&cs=srgb&fm=jpg&q=85",
  linen: "https://images.unsplash.com/photo-1591625591034-75d303d2e1a4?crop=entropy&cs=srgb&fm=jpg&q=85",
  door: "https://images.unsplash.com/photo-1779231927091-57962cf79e70?crop=entropy&cs=srgb&fm=jpg&q=85",
  groceries: "/assets/services/courses.webp",
  spa: "/assets/services/masseuse.webp",
  spaBed: "https://images.unsplash.com/photo-1787651343496-35b3666dd7d2?crop=entropy&cs=srgb&fm=jpg&q=85",
  chef: "https://images.unsplash.com/photo-1750943082012-efe6d2fd9e45?crop=entropy&cs=srgb&fm=jpg&q=85",
  chefPlating: "https://images.unsplash.com/photo-1775513153018-0c7ac7899751?crop=entropy&cs=srgb&fm=jpg&q=85",
  coach: "/assets/services/coach.webp",
  chauffeur: "/assets/services/chauffeur.webp",
  babysitter: "/assets/services/babysitter.webp",
  coiffeur: "https://images.unsplash.com/photo-1700760934268-8aa0ef52ce0a?crop=entropy&cs=srgb&fm=jpg&q=85",
  hero: "/assets/hero.webp",
  logoWhite: "/assets/logo-white.png",
  logoBlack: "/assets/logo-black.png",
};
